import { useState, useEffect } from "react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { t } from "i18next";
import { sendEmailVerificationAuth } from "@/services/auth";

export const NewVerifyEmailLinToast = (): JSX.Element => {
  const [timeLeft, setTimeLeft] = useState(0);
  const [hasRequestedOnce, setHasRequestedOnce] = useState(false);

  const formatTime = (seconds: number): string => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  useEffect(() => {
    if (timeLeft === 0) return;
    const interval = setInterval(() => {
      setTimeLeft((previous) => {
        if (previous <= 1) {
          clearInterval(interval);
          return 0;
        }
        return previous - 1;
      });
    }, 1000);

    return (): void => {
      clearInterval(interval);
    };
  }, [timeLeft]);

  const handleSendVerificationEmail = (): void => {
    if (!hasRequestedOnce || timeLeft === 0) {
      sendEmailVerificationAuth().catch(() => {
        // soft catch
      });
      setHasRequestedOnce(true);
      setTimeLeft(300);
    }
  };

  return (
    <Alert variant="info">
      <AlertTitle className="font-semibold">
        {t("login.components.newVerifyEmailLink.title")}
      </AlertTitle>
      <AlertDescription>
        {t("login.components.newVerifyEmailLink.description")}{" "}
        {!hasRequestedOnce || timeLeft === 0 ? (
          <span
            className="font-semibold underline cursor-pointer text-primary hover:text-primary/90"
            onClick={handleSendVerificationEmail}
          >
            {t("login.components.newVerifyEmailLink.requestNewLink")}
          </span>
        ) : (
          <span>
            {t("login.components.newVerifyEmailLink.youCanRequest")}{" "}
            <span className="font-semibold ">{formatTime(timeLeft)}</span>.
          </span>
        )}
      </AlertDescription>
    </Alert>
  );
};
